<template>
  <div class="container mt-4">
    <TopNav></TopNav>
    <div class="row mt-5">
      <div class="col-12 mb-4">
        <h1>{{ $t('DATA_IMPORT.TITLE.DATA_IMPORT') }}</h1>
        <span>
          {{ $t('DATA_IMPORT.TEXT.USING_DATA_IMPORT') }}<br />
          <a
            href="https://help.heymarvelous.com/en/collections/3718291-importing"
            class="d-block mt-2"
          >
            <i class="far fa-info-circle mr-2"></i>
            {{ $t('DATA_IMPORT.TEXT.REFER_TO_ARTICLE') }}
          </a>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-3 my-2">
        <router-link
          :to="{ name: 'data-import-students' }"
          class="undecorated-router-link"
        >
          <div class="import-card">
            <i class="fa fa-users c-brand-color"></i>
            <h4>{{ $t('DATA_IMPORT.TITLE.IMPORT_STUDENTS') }}</h4>
          </div>
        </router-link>
      </div>
      <div class="col-12 col-md-3 my-2">
        <router-link
          :to="{ name: 'data-import-purchases' }"
          class="undecorated-router-link"
        >
          <div class="import-card">
            <i class="fa fa-shopping-basket c-brand-color"></i>
            <h4>{{ $t('DATA_IMPORT.TITLE.IMPORT_PURCHASES') }}</h4>
          </div>
        </router-link>
      </div>
      <div class="col-12 col-md-3 my-2">
        <router-link
          :to="{ name: 'data-import-subscriptions' }"
          class="undecorated-router-link"
        >
          <div class="import-card">
            <i class="fa fa-recycle c-brand-color"></i>
            <h4>{{ $t('DATA_IMPORT.TITLE.IMPORT_SUBSCRIPTIONS') }}</h4>
          </div>
        </router-link>
      </div>
      <div class="col-12 col-md-3 my-2">
        <router-link
          :to="{ name: 'data-import-classcards' }"
          class="undecorated-router-link"
        >
          <div class="import-card">
            <i class="fa fa-ticket-alt c-brand-color"></i>
            <h4>{{ $t('DATA_IMPORT.TITLE.IMPORT_CLASSCARDS') }}</h4>
          </div>
        </router-link>
      </div>
      <div class="col-12 col-md-3 my-2">
        <router-link
          :to="{ name: 'data-import-media' }"
          class="undecorated-router-link"
        >
          <div class="import-card">
            <i class="fa fa-video-camera c-brand-color"></i>
            <h4>{{ $t('DATA_IMPORT.TITLE.IMPORT_MEDIA') }}</h4>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav';

export default Vue.extend({
  components: {
    TopNav,
  },
  name: 'DataImport',
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.import-card {
  border-radius: $border-radius;
  border: 1px solid $light-gray;
  padding: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  i {
    font-size: 32px;
    margin-bottom: 16px;
  }

  &:hover {
    box-shadow: 0 12px 12px -6px $dark-gray;
    transform: translateY(-4px);
  }
}
</style>
